import { render, staticRenderFns } from "./AlertModal.vue?vue&type=template&id=2da1fc96&scoped=true&"
import script from "./AlertModal.vue?vue&type=script&lang=js&"
export * from "./AlertModal.vue?vue&type=script&lang=js&"
import style0 from "./AlertModal.vue?vue&type=style&index=0&id=2da1fc96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da1fc96",
  null
  
)

export default component.exports